import { jsx as _jsx } from "react/jsx-runtime";
import { getLogoNamePropType } from '../utils/propTypes/logoName';
import UIAbstractIllustration from './UIAbstractIllustration';

const UILogo = props => /*#__PURE__*/_jsx(UIAbstractIllustration, Object.assign({}, props));

UILogo.defaultProps = UIAbstractIllustration.defaultProps;
UILogo.propTypes = Object.assign({}, UIAbstractIllustration.propTypes, {
  name: getLogoNamePropType().isRequired
});
UILogo.displayName = 'UILogo';
export default UILogo;